/**
 *    @author: Andrew Sheen
 *    @since:  2021-02-10
 *
 */

import { BirthPlace, Code, Confirm } from "src/refresh/service/constant";
import { Util } from "src/refresh/service/Util";
import { ItemList } from "../constant/item-list";
import { AdditionalParentInfoVO, BirthCertificateRequestVO } from "../data/app-vo";
import { AboutChild, Address, CCB, Eligibility, InputData, ParentInfo, SIN } from "../data/input-data";
import { BCSLBCreator } from "./BCSLBCreator";
var show = console.log.bind( console );

const OUNCES_TO_GRAMS = 28.349523124984255; 

const NOK_Mother = 56;
const NOK_Parent = 55;
const NOK_Legal  = 57;

export class BirthCertificateRequestCreator extends BCSLBCreator {

       BCRequest:BirthCertificateRequestVO;
       constructor(protected items:ItemList, protected data:InputData, protected todayMMDD:string) {
                   super();
       }

       public create() : BirthCertificateRequestVO {

              this.BCRequest = new BirthCertificateRequestVO();

              this.BCRequest.serviceType = 0;  // BC:0 BR:134

              let child:AboutChild = this.data.aboutChild;

              this.setChildName(child);
              this.setChildInfo(child);
              this.setLocation(child);
              this.setAttendant(child);
              this.setWeight(child);
              this.setOthers();

              //--------------------
              this.parentList();
              //--------------------

              this.setRelationship();
              this.setSINParents();
              this.setCCBCareGiver();

              return this.BCRequest;
       }

       //------------------------------------------------------------------------------------
       private setChildName(child:AboutChild) {
              if ( child.name.chk_singleName == Confirm.YES ) {
                   this.BCRequest.subjectSurname = this.toUpperCase(child.name.single);
              }
              else {
                   this.BCRequest.subjectSurname    = this.toUpperCase(child.name.last);
                   this.BCRequest.subjectMiddleName = this.toUpperCase(child.name.middle);
                   this.BCRequest.subjectGivenName  = this.toUpperCase(child.name.first);
              }
       }

       //------------------------------------------------------------------------------------
       private setChildInfo(child:AboutChild) {
               this.BCRequest.subjectSex = child.gender;
               this.BCRequest.subjectDeceasedIndcator = child.isChildDeceased;
               this.BCRequest.placeOfEvent = this.toUpperCase(child.cityName); // lookup.City or Other City
               this.BCRequest.dateOfBirth = child.birthDay;
       }

       //------------------------------------------------------------------------------------
       private setLocation(child:AboutChild) {

            let locationType:string = 'U';
            if (      child.birthPlaceType == BirthPlace.Hospital )    locationType = '0';
            else if ( child.birthPlaceType == BirthPlace.BirthCenter ) locationType = '2';
            else if ( child.birthPlaceType == BirthPlace.Home )        locationType = '1';
            else if ( child.birthPlaceType == BirthPlace.Other )       locationType = '3';

            this.BCRequest.locationType  = locationType;

            if ( locationType == '0' || locationType == '2' ) {
                 this.BCRequest.nameOfHospital    = this.toUpperCase(child.birthPlaceName);
            }
            else this.BCRequest.locationTypeOther = this.toUpperCase(child.birthPlaceName);
       }

       //------------------------------------------------------------------------------------
       private setAttendant(child:AboutChild) {

               this.BCRequest.attendantDesignation = child.attendentType;
               
               if ( child.attendentSingleName )
                    this.BCRequest.attendantLastName = this.toUpperCase(child.attendentSingleName);
               else {
                    this.BCRequest.attendantLastName = this.toUpperCase(child.attendentLastName);
                    this.BCRequest.attendantFirstName   = this.toUpperCase(child.attendentFirstName);
               }
       }

       //------------------------------------------------------------------------------------
       private setWeight(child:AboutChild) {

              if ( Util.isEmpty(child.grams) == false  ) {
                   this.BCRequest.weightOfChild = child.grams;
              }
              else {
                   if ( !child.ounces ) child.ounces = 0;
                   let ounces = child.ounces + (child.pounds?child.pounds*16 : 0);
                   this.BCRequest.weightOfChild = Math.round(ounces * OUNCES_TO_GRAMS);
              }
       }

       //------------------------------------------------------------------------------------
       private setOthers()  {

              this.BCRequest.outOfProvince = "N";
              this.BCRequest.childrenBorn = 0;   // always 0

              this.BCRequest.bookYear = 0;
              this.BCRequest.searchYearFrom = 0;
              this.BCRequest.searchYearTo = 0;
              this.BCRequest.registrationNumber = 0;
              this.BCRequest.validFromIndicator = 'Y';
              this.BCRequest.requestReasonType = 0;
              this.BCRequest.applicantSignatureIndicator = 'X';
              ////this.BCRequest.CorrespondenceSignedIndicator = '*';

              this.BCRequest.prevCertificateIndicator = 'N';
              this.BCRequest.prevParentalCertificateIndicator = 'N';
              this.BCRequest.prevCertified = 'N';
              this.BCRequest.prevNameChangeIndicator = 'N';

              this.BCRequest.additionalInfoIndicator = 'X';

              this.BCRequest.guarantorSignaturePresent = 'X';
              this.BCRequest.guarantorInfoPresent = 'X';
              this.BCRequest.proofOfdeathAttached = 'X';
              this.BCRequest.guarantorValid = 'X';
              this.BCRequest.proofOfCustodyIndicator = 'X';  // or 'A'
       }



       //==================================================================================
       private setRelationship() {
            let isDeceased = this.data.aboutChild.isChildDeceased == Confirm.YES;

            if ( this.data.eligibility.isOtherCertifyingBirth == Confirm.YES ) 
                 this.BCRequest.subjectRelationship = (isDeceased?NOK_Legal:3);   
            else     
            if ( this.data.applicantParent.parentTitle == 1 )   // if Mother      
                 this.BCRequest.subjectRelationship = (isDeceased?NOK_Mother:1);
            else this.BCRequest.subjectRelationship = (isDeceased?NOK_Parent:2);
       }

       //------------------------------------------------------------------------------------
       private setSINParents() {
               let  sinData:SIN = this.data.SIN;
               if ( sinData.chk_read == false ) return;

               let parentList = this.data.parentList;

               for ( let i = 0; i < this.data.eligibility.listedParentCount; i++ ) {

                     if ( parentList[i].isSINParent ) {
                          if ( !this.BCRequest.notificationSinParent1 ) {
                                this.BCRequest.notificationSinParent1 = parentList[i].parentTitle;
                          }
                          else  { 
                                this.BCRequest.notificationSinParent2 = parentList[i].parentTitle;
                                break;
                          }
                     }  
               }

               //console.log("this.BCRequest.notificationSinParent1",this.BCRequest.notificationSinParent1);
               //console.log("this.BCRequest.notificationSinParent2",this.BCRequest.notificationSinParent2);
       }

       //------------------------------------------------------------------------------------
       private setCCBCareGiver() {

              if ( this.data.CCB.chk_consent && this.data.CCB.primaryCaregiver >= 0 ) 

                   this.BCRequest.ccbCareGiver = this.data.parents[this.data.CCB.primaryCaregiver].parentTitle;

       }


       //====================================================================================
       private parentList() {

            let parentList = this.data.parentList;

            this.createMother(parentList[0]);

            let hasFather:boolean = false;

            for ( let i = 1; i < this.data.eligibility.listedParentCount; i++ ) {

                  let  parent = parentList[i];
                  if ( !hasFather ) {
                        hasFather = true;
                        this.createFather(parent);
                  }
                  else 
                        this.createParent(parent);
            }
       }


       //====================================================================================
       private createMother(parent:ParentInfo) {

              parent.parentTitle = 1; // mother

              this.BCRequest.motherParentType = Number(parent.parentType);

              this.BCRequest.motherSurname    = this.toUpperCase(parent.name.getSingleOrLast());
              this.BCRequest.motherGivenName  = this.toUpperCase(parent.name.first);
              this.BCRequest.motherMiddleName = this.toUpperCase(parent.name.middle);
              this.BCRequest.motherMaidenName = this.toUpperCase(parent.lastNameAtBirth);
              this.BCRequest.motherPreviousSurname = this.toUpperCase(this.BCRequest.motherSurname + " " + parent.previousLastName);
              if ( this.BCRequest.motherPreviousSurname.length > 80 ) 
                   this.BCRequest.motherPreviousSurname = this.BCRequest.motherPreviousSurname.substring(0,80);

              this.BCRequest.motherMaritalStatus = parent.maritalStatus;
              this.BCRequest.motherDateOfBirth   = parent.whenParentBorn;
              this.BCRequest.motherAge = Util.age(parent.whenParentBorn,this.data.aboutChild.birthDay);

              this.BCRequest.motherPlaceOfBirthCity = this.toUpperCase(parent.placeOfBirth.city);
              this.BCRequest.motherPlaceOfBirthCountry = super.getCountryCode(parent.placeOfBirth); 
              this.BCRequest.motherPOBCountry = this.toUpperCase(parent.placeOfBirth.otherCountry);

              this.motherAddress();

              let ccb:CCB = this.data.CCB;
              if ( ccb.chk_consent == true ) {
                   this.BCRequest.motherSin = Number( Util.padZero(ccb.SSN1,3)+
                                                      Util.padZero(ccb.SSN2,3)+
                                                      Util.padZero(ccb.SSN3,3));
              }              
       }

       private motherAddress() {

               if ( !this.data.motherContact ) return;

               let motherAddr:Address = this.data.motherContact.address;
               if ( this.data.contact.isParentSameAddr == Confirm.YES )
                    motherAddr = this.data.contact.address;

               this.BCRequest.motherStreetNumber = this.toUpperCase(motherAddr.streetNumber);
               this.BCRequest.motherStreetName   = this.toUpperCase(motherAddr.streetName);
               this.BCRequest.motherCity  = this.toUpperCase(motherAddr.base.city);
               this.BCRequest.motherProvinceCountry = super.getCountryCode(motherAddr.base); 
               this.BCRequest.motherProvinceCountryOther = this.toUpperCase(motherAddr.base.otherCountry);

               this.BCRequest.motherPostalCode = this.toUpperCase(motherAddr.postalCode);
       }

       //==============================================================================
       private createFather(parent:ParentInfo) {

              parent.parentTitle = 2; // father
              this.BCRequest.fatherInfoNotProvided = Confirm.YES;

              this.BCRequest.fatherParentType = Number(parent.parentType);

              this.BCRequest.fatherSurname    = this.toUpperCase(parent.lastNameAtBirth); // not lastName
              this.BCRequest.fatherGivenName  = this.toUpperCase(parent.name.first);
              this.BCRequest.fatherMiddleName = this.toUpperCase(parent.name.middle);
              this.BCRequest.fatherPreviousName = this.toUpperCase( parent.name.getSingleOrLast() + " " + parent.previousLastName);
              if ( this.BCRequest.fatherPreviousName.length > 80 ) 
                   this.BCRequest.fatherPreviousName = this.BCRequest.fatherPreviousName.substring(0,80);


              this.BCRequest.fatherAge = Util.age(parent.whenParentBorn,this.data.aboutChild.birthDay);
              this.BCRequest.fatherDateOfBirth = parent.whenParentBorn;

              this.BCRequest.fatherPlaceOfBirthCity = this.toUpperCase(parent.placeOfBirth.city);
              this.BCRequest.fatherPlaceOfBirthCountry = super.getCountryCode(parent.placeOfBirth); 
              this.BCRequest.fatherPOBCountry = this.toUpperCase(parent.placeOfBirth.otherCountry);
       }

       //==============================================================================
       private createParent(parent:ParentInfo) {

              if ( !this.BCRequest.additionalParents ) this.BCRequest.additionalParents = [];
              
              let parentEx = new AdditionalParentInfoVO();

              this.BCRequest.additionalParents.push(parentEx);

              parent.parentTitle = this.BCRequest.additionalParents.length + 2;  // length=1:parent3 length=2:parent4

              parentEx.parentType = Number(parent.parentType);

              parentEx.parentSurname    = this.toUpperCase(parent.lastNameAtBirth);  // not lastName
              parentEx.parentGivenName  = this.toUpperCase(parent.name.first);
              parentEx.parentMiddleName = this.toUpperCase(parent.name.middle);
              parentEx.parentPreviousName = this.toUpperCase(parent.name.getSingleOrLast() + " " + parent.previousLastName);
              if ( parentEx.parentPreviousName.length > 80 ) 
              parentEx.parentPreviousName = parentEx.parentPreviousName.substring(0,80);

              parentEx.parentDateOfBirth = parent.whenParentBorn;
              parentEx.parentAge = Util.age(parent.whenParentBorn,this.data.aboutChild.birthDay);

              parentEx.parentPlaceOfBirthCity    = this.toUpperCase(parent.placeOfBirth.city);
              parentEx.parentPlaceOfBirthCountry = super.getCountryCode(parent.placeOfBirth); 
              parentEx.parentPOBCountry = this.toUpperCase(parent.placeOfBirth.otherCountry);
      }
}